import { fromPromise, type DoneActorEvent } from 'xstate';

import { type TelemetryCartHandoffBag } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────────────

const fetchInitialData = fromPromise<FetchInitialDataResponse, FetchInitialDataParams>(async () => {
  return {
    orderToken: undefined,
    hasActiveBag: false,
  };
});

const handoffCart = fromPromise<HandoffCartResponse, HandoffCartParams>(async () => {
  return {
    isSuccess: false,
    hasNothingAvailable: false,
    conflicts: [],
    telemetryBag: null,
  };
});

export const CartHandoffActors = {
  fetchInitialData,
  handoffCart,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type FetchInitialDataEvent = DoneActorEvent<FetchInitialDataResponse, 'fetchInitialData'>;
export type FetchInitialDataParams = void;
export type FetchInitialDataResponse = {
  orderToken: string | undefined;
  hasActiveBag: boolean;
};

export type HandoffCartEvent = DoneActorEvent<HandoffCartResponse, 'handoffCart'>;
export type HandoffCartParams = { orderToken: string; ignoreConflicts: boolean };
export type HandoffCartResponse = {
  isSuccess: boolean;
  hasNothingAvailable: boolean;
  conflicts: string[];
  telemetryBag: null | TelemetryCartHandoffBag;
};
